export const world_religion =
{
    'id': 'world_religion',
    'type': 'fill',
    'source': 'world_religion',
    'maxzoom': 5.99,
    'source-layer': 'BRI_Religion_JSON2',
    'paint': {
        'fill-antialias': true,
        'fill-opacity': 1,
        'fill-outline-color':"hsla(0, 0%, 0%, 20%)",
        'fill-color': [
          "match",
          ["get", "HighRelig"],
          ["Muslims(Sunni)"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "hsl(120, 50%, 80%)",
            50,
            "hsl(120, 50%, 65%)",
            70,
            "hsl(120, 50%, 45%)",
            90,
            "hsl(120, 50%, 25%)"
          ],
          ["Protestants"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#c1d0f0",
            50,
            "#84a1e1",
            70,
            "#4673d2",
            90,
            "#2d59b9"
          ],
          [
            "Buddhists(Tibetan Buddhism)"
          ],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "hsl(60, 100%, 93%)",
            50,
            "hsl(60, 98%, 80%)",
            70,
            "hsl(60, 99%, 60%)",
            90,
            "hsl(60, 99%, 40%)"
          ],
          ["East Asian Religiosity"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#ffc2b3",
            50,
            "#ff704d",
            70,
            "#ff3300",
            90,
            "#cc2900"
          ],
          ["Hindus"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "hsl(30, 50%, 85%)",
            50,
            "hsl(30, 50%, 65%)",
            70,
            "hsl(30, 50%, 45%)",
            90,
            "hsl(30, 50%, 30%)"
          ],
          [
            "Ethnic and other religionists"
          ],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#ffccf2",
            50,
            "#ff80df",
            70,
            "#ff1ac6",
            90,
            "#cc0099"
          ],
          ["Oriental orthodox"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#ccccff",
            50,
            "#4d4dff",
            70,
            "#0000cc",
            90,
            "#000080"
          ],
          ["Catholics"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#d9b3ff",
            50,
            "#a64dff",
            70,
            "#7300e6",
            90,
            "#400080"
          ],
          ["Buddhists(Theravada)"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            0,
            "#fff5dc",
            40,
            "#fed777",
            60,
            "#ffb31a",
            80,
            "#e69900"
          ],
          ["Eastern orthodox"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#d0d0e1",
            50,
            "#a2a2c3",
            70,
            "#7373a5",
            90,
            "#50507c"
          ],
          [
            "Muslims(Non-denominational)"
          ],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#d1e0e0",
            50,
            "#85adad",
            70,
            "#5c8a8a",
            90,
            "#476b6b"
          ],
          ["Buddhists(Mahayana)"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#e6ffb3",
            50,
            "#ccff66",
            70,
            "#aaff00",
            90,
            "#77b300"
          ],
          ["Muslims(Shia)"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#e5e5cc",
            50,
            "#c2c289",
            70,
            "#a8a857",
            90,
            "#666633"
          ],
          ["Muslims(Ibadi)"],
          [
            "interpolate",
            ["linear"],
            ["get", "Numerical"],
            30,
            "#ccffff",
            50,
            "#00e6e6",
            70,
            "#009999",
            90,
            "#004d4d"
          ],
          ["Mormons"],
          "#bfbfbf",
          "#ebeaea"
        ]
    },
    'layout': {
        'visibility': 'visible'
    }
}
